var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoUsersSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 101,
    viewBox: "0 0 128 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2284 41.4171C68.1654 41.4171 70.5462 39.0336 70.5462 36.0933C70.5462 33.1531 68.1654 30.7695 65.2284 30.7695C62.2915 30.7695 59.9106 33.1531 59.9106 36.0933C59.9106 39.0336 62.2915 41.4171 65.2284 41.4171Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3556 41.4171C85.2926 41.4171 87.6734 39.0336 87.6734 36.0933C87.6734 33.1531 85.2926 30.7695 82.3556 30.7695C79.4187 30.7695 77.0378 33.1531 77.0378 36.0933C77.0378 39.0336 79.4187 41.4171 82.3556 41.4171Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2284 70.2384C68.1654 70.2384 70.5462 67.8549 70.5462 64.9146C70.5462 61.9744 68.1654 59.5908 65.2284 59.5908C62.2915 59.5908 59.9106 61.9744 59.9106 64.9146C59.9106 67.8549 62.2915 70.2384 65.2284 70.2384Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3556 70.2384C85.2926 70.2384 87.6734 67.8549 87.6734 64.9146C87.6734 61.9744 85.2926 59.5908 82.3556 59.5908C79.4187 59.5908 77.0378 61.9744 77.0378 64.9146C77.0378 67.8549 79.4187 70.2384 82.3556 70.2384Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4829 41.4171C102.42 41.4171 104.801 39.0336 104.801 36.0933C104.801 33.1531 102.42 30.7695 99.4829 30.7695C96.546 30.7695 94.1652 33.1531 94.1652 36.0933C94.1652 39.0336 96.546 41.4171 99.4829 41.4171Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0505 46.1417L54.2818 40.4521",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7532 60.2601L43.5996 54.6172",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.182 24.8389H59.5297C56.6314 24.8389 54.2819 27.191 54.2819 30.0926V42.0867C54.2819 44.9882 56.6314 47.3404 59.5297 47.3404H105.182C108.08 47.3404 110.43 44.9882 110.43 42.0867V30.0926C110.43 27.191 108.08 24.8389 105.182 24.8389Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.182 53.6602H59.5297C56.6314 53.6602 54.2819 56.0123 54.2819 58.9139V70.908C54.2819 73.8095 56.6314 76.1617 59.5297 76.1617H105.182C108.08 76.1617 110.43 73.8095 110.43 70.908V58.9139C110.43 56.0123 108.08 53.6602 105.182 53.6602Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8105 63.7473C38.1185 63.7473 44.0428 57.8164 44.0428 50.5001C44.0428 43.1839 38.1185 37.2529 30.8105 37.2529C23.5025 37.2529 17.5782 43.1839 17.5782 50.5001C17.5782 57.8164 23.5025 63.7473 30.8105 63.7473Z",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11 2.44629H12.8902C6.84454 2.44629 1.9436 7.35276 1.9436 13.4052V87.5957C1.9436 93.6482 6.84454 98.5546 12.8902 98.5546H115.11C121.155 98.5546 126.056 93.6482 126.056 87.5957V13.4052C126.056 7.35276 121.155 2.44629 115.11 2.44629Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 100,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsersSelected);
export default __webpack_public_path__ + "static/media/no-users-selected.badb2c24bd3d2aa13f4013701a762191.svg";
export { ForwardRef as ReactComponent };